import { AdminTranslations, ApiResponse } from "../../types/admin";
import httpClient from "../httpClient";

export const translationsApi = {
  getAll: (): Promise<ApiResponse<AdminTranslations>> =>
    httpClient.get("/translations"),

  update: (translations: AdminTranslations): Promise<ApiResponse<AdminTranslations>> =>
    httpClient.put("/translations", translations),
};
